import {FC} from "react";
import {Link, Stack, Typography} from "@mui/material";
import ConsentCheckbox from "./ConsentCheckbox";
import {routes} from "../../../utils/routes";

interface IProps {
    acceptTerms: boolean;
    acceptPdConsent: boolean;
    onChangeTerms: (v: boolean) => void;
    onChangePdConsent: (v: boolean) => void;
    /** Показать ошибку (после попытки submit без галочек). */
    showError?: boolean;
}

const docLink = (to: string, label: string) => (
    <Link href={to} target="_blank" rel="noopener noreferrer">
        {label}
    </Link>
);

/**
 * Два РАЗДЕЛЬНЫХ чекбокса согласия (требование 152-ФЗ с 01.09.2025 — нельзя
 * одной галочкой принимать и Пользовательское соглашение, и согласие на ПДн).
 * Не предзаполнены. Документы открываются в новой вкладке, чтобы не терять
 * прогресс формы.
 */
const ConsentFields: FC<IProps> = ({
                                       acceptTerms,
                                       acceptPdConsent,
                                       onChangeTerms,
                                       onChangePdConsent,
                                       showError = false,
                                   }) => {
    const termsError = showError && !acceptTerms;
    const pdError = showError && !acceptPdConsent;

    return (
        <Stack spacing={0.5}>
            <ConsentCheckbox
                id="accept_terms"
                checked={acceptTerms}
                onChange={onChangeTerms}
                error={termsError}
                label={<>Принимаю {docLink(routes.legalTerms, "Пользовательское соглашение")}</>}
            />
            <ConsentCheckbox
                id="accept_pd_consent"
                checked={acceptPdConsent}
                onChange={onChangePdConsent}
                error={pdError}
                label={
                    <>
                        Даю {docLink(routes.legalConsent, "согласие на обработку персональных данных")} и
                        ознакомлен с {docLink(routes.legalPrivacy, "Политикой конфиденциальности")}
                    </>
                }
            />
            {(termsError || pdError) && (
                <Typography variant="caption" color="error.main" sx={{pl: "30px"}}>
                    Отметьте оба согласия, чтобы продолжить
                </Typography>
            )}
        </Stack>
    );
};

export default ConsentFields;
